import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id A7695AE5-5CF1-42B3-BBAE-516D143CF87C
 * name file-document-minus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-minus.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentMinusIcon = createSvgIcon(<><path d="M15 18H23V20H15M6 2C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 18.67 13.03 18.33 13.08 18H6V16H13.81C14.27 15.2 14.91 14.5 15.68 14H6V12H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M13 3.5L18.5 9H13Z" /></>, 'FileDocumentMinusIcon');
export default FileDocumentMinusIcon